import BaseModelAPI from '../BaseModelAPI';

export default class PostingSupplyDetailForProduction extends BaseModelAPI {
	static entity = 'postingsupplydetailforproduction';
	static entityName = 'postingsupplydetailforproduction';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.postingSupplyForProductionId = '';
		this.postingSupplyForProduction = {};
		this.pickingSupplyForProductionDetailId = '';
		this.pickingSupplyForProductionDetail = {};
		this.partId = '';
		this.part = {};
		this.materialPartId = '';
		this.materialPart = {};
		this.qtySupply = 0;
		this.picPickingId = '';
		this.picPicking = {};
		this.picPenerimaId = '';
		this.picPenerima = {};
		this.lineId = '';
		this.line = {};
		this.postingDate = '';
		this.areaId = '';
		this.area = {};
		this.rackId = '';
		this.rack = {};
		this.documentStatusId = '';
		this.documentStatus = {};
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.isScanned = '';
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		this.materialPartCombination = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async getListView(this_, filter, sorting, pageIndex, pageSize, persistBy) {
		let filterArray = Array();
		if (filter != null && filter != undefined) {
			// console.log(filter);
			filterArray = this.getFilter(filter);
		}
		if (sorting != null && sorting != undefined) {
			Object.entries(sorting).map(([key, value]) => {
				if (key != '') {
					filterArray.push("sorting[" + key + "]=" + (value ? "1" : "0"));     // draftFromUpload & draftMode
				}
			});

		}
		if (pageIndex != null) {
			filterArray.push("pageIndex=" + pageIndex);
		}
		if (pageSize != null) {
			filterArray.push("pageSize=" + pageSize);
		}
		let params = "";
		if (filterArray.length > 0) {
			params = "?" + filterArray.join("&");
		}

		//DEBUG

		return this_.$http.get(`${this.entityName}/getlistview` + params)
			.then(response => {
				if (response != null) {
					return response.data;
				}
				return response;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}


}